import { css } from "styled-components";

/**
 * Theme transition styles for View Transitions API.
 * Provides smooth crossfade animation when toggling between light and dark themes.
 */
export const themeTransitionStyles = css`
    ::view-transition-old(root),
    ::view-transition-new(root) {
        animation-duration: 1250ms;
        animation-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
    }

    ::view-transition-old(root) {
        animation-name: smooth-fade-out;
    }

    ::view-transition-new(root) {
        animation-name: smooth-fade-in;
    }

    @keyframes smooth-fade-out {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }

    @keyframes smooth-fade-in {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
